var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"bg-light"},[_c('v-container',{attrs:{"fill-height":""}},[_c('ChatSection',{staticClass:"chat-section"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }